module.exports = "<div *ngIf=\"displayLeftNav\" class=\"left-nav hidden-print\">\n    <my-left-navigation></my-left-navigation>\n</div>\n<div class=\"content-wrapper\">\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-content.component.html
// module id = 1514
// module chunks = 0